import { render, staticRenderFns } from "./LeadPipelineStageLabel.vue?vue&type=template&id=34f64250&scoped=true"
import script from "./LeadPipelineStageLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeadPipelineStageLabel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LeadPipelineStageLabel.vue?vue&type=style&index=0&id=34f64250&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f64250",
  null
  
)

export default component.exports